import { MessagePreview } from '@web/conversations/Message/MessagePreview/MessagePreview';

import { useQuotedMessagePreview } from './quotedMessagePreview.hooks';
import { Button, CloseIcon, Wrapper } from './quotedMessagePreview.styles';

export const QuotedMessagePreview = () => {
  const { quotedMessage, unselectQuotedMessage } = useQuotedMessagePreview();

  return quotedMessage ? (
    <Wrapper>
      <MessagePreview message={quotedMessage} />

      <Button onClick={unselectQuotedMessage}>
        <CloseIcon />
      </Button>
    </Wrapper>
  ) : null;
};
